import { render, staticRenderFns } from "./PrimaryPurpose.vue?vue&type=template&id=57a41aca"
import script from "./PrimaryPurpose.vue?vue&type=script&lang=ts"
export * from "./PrimaryPurpose.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports